// src/Redux/Store.js
import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./CartSlice";
import cartSliderReducer from "./cartSliderSlice";
import ratingReducer from "./ratingSlice";
import wishlistReducer from "./wishlistSlice"; // ✅ Add this

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    cartSlider: cartSliderReducer,
    rating: ratingReducer,
    wishlist: wishlistReducer, // ✅ Add this
  },
});